import WhatIsIncluded from "./WhatIsIncluded";

export default WhatIsIncluded;
